import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 保存主动发送的消息
export function webSaveChatRecord(from_id,to_id,content,type,otherParam,callback){
	let is_send = 2
	if(otherParam.is_send !== undefined){
		is_send = otherParam.is_send
	}
	request({
			method: 'post',
			url: 'ChatRecord/saveMsg',
			data: {
			  from_id: from_id,
		      to_id: to_id,
			  content: content,
			  type: type,
			  is_new: 0,
			  is_send: is_send,
			  send_manager_id: getLoginId()
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			CHAT_LAYER.msg(response.data.msg,{icon:2})
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据id，获取聊天记录
export function webGetChatRecord(id,callback){
	request({
			method: 'post',
			url: 'ChatRecord/getById',
			data: {
			 id: id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取服务器的聊天记录列表，包括普通聊天和群聊天的
/**
 * @param {Object} id 粉丝id或者群id
 * @param {Object} type 类型：fans/cluster
 * @param {Object} callback
 */
export function webGetChatRecordList(param,callback){
	request({
			method: 'post',
			url: 'ChatRecord/getMixListWithPage',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取服务器的聊天记录列表，包括普通聊天和群聊天的，以id为条件分页
/**
 * @param {Object} id 粉丝id或者群id
 * @param {Object} type 类型：fans/cluster
 * @param {Object} callback
 */
export function webGetChatRecordListWithId(param,callback){
	request({
			method: 'post',
			url: 'ChatRecord/getMixList',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 获取服务器的聊天记录列表，包括普通聊天和群聊天的，以发送时间为条件分页
 * @param {Object} id 粉丝id或者群id
 * @param {Object} type 类型：fans/cluster
 * @param {Object} callback
 */
export function webGetChatRecordListWithTime(param,callback){
	request({
			method: 'post',
			url: 'ChatRecord/getMixListWithTime',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据id，获取聊天记录
export function webUpdateRecodeWithRR(type,money,paymsgid,transferid,callback){
	request({
			method: 'post',
			url: 'ChatRecord/updateRecodeWithRR',
			data: {
				 type: type,
				 money: money,
				 paymsgid: paymsgid,
				 transferid: transferid,
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据id，删除聊天记录-软删除
export function webDeleteChatRecord(id,callback){
	request({
			method: 'post',
			url: 'ChatRecord/deleteById',
			data: {
			 id: id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}